import { $drawMode, $interactivity, $mapLoaded } from './stores.js';
import {
  changeDrawModeEv,
  changeInteractivityEv,
  resetMapLoadedEv,
  setMapLoadedEv,
} from './events.js';

$mapLoaded.on(setMapLoadedEv, (_, payload) => payload).reset(resetMapLoadedEv);

$interactivity.on(changeInteractivityEv, (_, payload) => payload);

$drawMode.on(changeDrawModeEv, (_, payload) => payload);
